import React, { FC, useEffect, useState } from 'react'
import { getImage } from '../../../../app/utlis/imageConstants';
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg';
import { motion } from 'framer-motion';
import Screen1 from '../../../../app/assets/images/projectImage/aichatImage/screen1.png'
import Screen2 from '../../../../app/assets/images/projectImage/aichatImage/screen2.png'
import Screen3 from '../../../../app/assets/images/projectImage/aichatImage/screen3.png'
import Screen4 from '../../../../app/assets/images/projectImage/aichatImage/screen4.png'
import Screen5 from '../../../../app/assets/images/projectImage/aichatImage/screen5.png'
import FRAME from '../../../../app/assets/images/projectImage/aichatImage/app-phone-layout.png'

interface AIChatProjectContentProps {
    aiChatProject: any
}

const AIChatProjectContent: FC<AIChatProjectContentProps> = ({ aiChatProject }) => {
    const [activeIndex, setActiveIndex] = useState(2);
    const [images, setImages] = useState([Screen1, Screen2, Screen3, Screen4, Screen5]);
    const [isMobile, setIsMobile] = useState(false);

    // Desktop positions for the image carousel (centered)
    const desktopPositions = [
        { left: 'calc(50% - 350px)', scale: 0.7, zIndex: 10 },
        { left: 'calc(50% - 200px)', scale: 1, zIndex: 20 },
        { left: 'calc(50% - 0px)', scale: 1.3, zIndex: 50 },
        { left: 'calc(50% + 200px)', scale: 1, zIndex: 20 },
        { left: 'calc(50% + 350px)', scale: 0.7, zIndex: 10 }
    ];

    // Mobile positions (simplified, focused on center)
    const mobilePositions = [
        { left: 'calc(50% - 120px)', scale: 0.5, zIndex: 10 },
        { left: 'calc(50% - 80px)', scale: 0.7, zIndex: 20 },
        { left: 'calc(50% - 0px)', scale: 1, zIndex: 50 },
        { left: 'calc(50% + 80px)', scale: 0.7, zIndex: 20 },
        { left: 'calc(50% + 120px)', scale: 0.5, zIndex: 10 }
    ];

    useEffect(() => {
        // Check for mobile viewport on mount and resize
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        const interval = setInterval(() => {
            rotateImages(); // Uncomment to enable auto-rotation
        }, 3000); // Adjust the speed of the transition here

        return () => {
            clearInterval(interval); // Cleanup on unmount
            window.removeEventListener('resize', checkMobile);
        }
    }, [images]);

    // Function to rotate images (move positions)
    const rotateImages = () => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % images.length); // Increment index and reset at the end
    };

    // Get the appropriate positions based on viewport
    const positions = isMobile ? mobilePositions : desktopPositions;

    return (
        <div className='px-4 sm:px-8 md:px-12 overflow-hidden'>
            <div className="relative flex justify-center items-center h-[350px] sm:h-[450px] md:h-[550px] lg:h-[653px]">
                {!isMobile && <div className='absolute left-1/2 transform -translate-x-1/2 md:top-11 lg:top-0 w-[220px] lg:w-[328px] h-[460px] lg:h-[651px] z-40 scale-75 sm:scale-90 md:scale-100'>
                    <img src={FRAME} className='absolute w-full h-full' />
                </div>}
                {images.map((image, index) => {
                    const positionIndex = (index - activeIndex + images.length) % images.length;
                    const { left, scale, zIndex } = positions[positionIndex];

                    const mainScale = isMobile ? 0.9 : 1.3;

                    return scale === (isMobile ? 1 : 1.3) ? (
                        <div key={index} className="z-20 absolute transition-all duration-1000 ease-in-out"
                            style={{ transform: `translateX(-50%) scale(${scale})`, zIndex, left }}>
                            <div className='flex items-center justify-center w-[180px] lg:w-[250px] h-[360px] lg:h-[500px]'>
                                <img
                                    src={image}
                                    alt={`Screen ${index + 1}`}
                                    className="relative w-full h-full rounded-2xl shadow-lg z-50 p-[_10px_11px_12px_10px]"
                                />
                            </div>
                        </div>
                    ) : (
                        <div key={index} className="absolute transition-all duration-1000 ease-in-out"
                            style={{ transform: `translateX(-50%) scale(${scale})`, zIndex, left }}>
                            <img
                                src={image}
                                alt={`Screen ${index + 1}`}
                                className="w-[170px]  lg:w-[250px] h-[360px]  lg:h-[500px] rounded-2xl shadow-lg"
                            />
                        </div>
                    );
                })}
            </div>

           <motion.div
  className="
    grid grid-cols-2
    gap-6
    p-4 md:py-8 lg:p-16 pt-16
    md:flex md:flex-row lg:justify-center lg:items-start lg:gap-16
  "
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, margin: "-100px" }}
  variants={{
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  }}
>
  {aiChatProject.aichatProjectDetails.websiteDetails.map(
    (detail: any, index: number) => {
      const img = getImage(detail?.image ?? "") ?? "";

      return (
        <motion.div
          key={index}
          className="w-full h-full"
          variants={{
            hidden: { opacity: 0, y: 30 },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                type: "spring",
                damping: 15,
                stiffness: 100,
              },
            },
          }}
        >
          <motion.div
            className="p-4 sm:p-6 rounded-3xl flex flex-col items-center gap-4 w-full h-full"
            whileHover="hover"
            initial="initial"
            variants={{
              initial: {},
              hover: {
                scale: 1.05,
                boxShadow: "0px 10px 25px rgba(33, 53, 255, 0.2)",
                transition: { duration: 0.2 },
              },
            }}
          >
            {/* Icon */}
            <motion.div
              className="w-16 h-16 sm:w-20 sm:h-20 rounded-full flex items-center justify-center bg-[#2135FF]"
              variants={{
                hover: {
                  rotate: [0, -10, 10, -10, 0],
                  scale: 1.1,
                  transition: {
                    rotate: {
                      repeat: Infinity,
                      duration: 1.5,
                    },
                    scale: {
                      duration: 0.2,
                    },
                  },
                },
              }}
            >
              <motion.div
                className="flex items-center justify-center text-black font-black text-xl"
                variants={{
                  hover: {
                    scale: 1.1,
                  },
                }}
              >
                <DynamicSVG color="#fff">{img}</DynamicSVG>
              </motion.div>
            </motion.div>

            {/* Content */}
            <motion.div
              className="flex flex-col items-center text-center flex-1 min-h-[80px]"
              variants={{
                hover: {
                  y: -5,
                  transition: { duration: 0.2 },
                },
              }}
            >
              <motion.span
                className="text-lg sm:text-xl font-medium text-white"
                variants={{
                  hover: {
                    color: "#2135FF",
                    transition: { duration: 0.2 },
                  },
                }}
              >
                <b>{detail.title}</b>
              </motion.span>

              <span className="text-sm sm:text-base text-[#E0E0E0] mt-1">
                {detail.sub_title}
              </span>
            </motion.div>
          </motion.div>
        </motion.div>
      );
    }
  )}
</motion.div>
        </div>
    )
}

export default AIChatProjectContent
